/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e="system",t="unknown",n="UTC",o=Intl.DateTimeFormat().resolvedOptions().timeZone;export{e as system,o as systemTimeZone,t as unknown,n as utc};
